import {NgModule} from '@angular/core';
import {EnergyMapComponent} from './energy-map/energy.map.component';
import {AdvisorSharedModule} from './advisor.shared.module';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';
import {EnergyMapOverlayComponent} from './energy-map/energy.map.overlay.component';
import {EnergyMapAddressComponent} from './energy-map/energy.map.address.component';
import {EnergyMapDonatedComponent} from './energy-map/energy.map.donated.component';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatInputModule} from "@angular/material/input";

/**
 * Shared module between the advisors that share components for the energy-map. Must bei included in all modules that needs it.
 */
@NgModule({
  declarations: [EnergyMapComponent, EnergyMapOverlayComponent, EnergyMapAddressComponent, EnergyMapDonatedComponent],
  imports: [AdvisorSharedModule, ReactiveFormsModule, TranslateModule, RouterModule, MatFormFieldModule, MatAutocompleteModule, MatInputModule],
  exports: [EnergyMapComponent, EnergyMapOverlayComponent, EnergyMapAddressComponent, EnergyMapDonatedComponent],
})
export class AdvisorEnergyMapModule {
}
